// src/pages/SmartyVision.jsx
import React from "react";
import { useNavigate, Link } from "react-router-dom";

const SmartyVision = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-teal-100 font-sans flex flex-col">
      <header className="sticky top-0 z-50 bg-black border-b border-teal-800 px-4 py-3 flex items-center justify-between shadow-md">
        <h1 className="text-lg lg:text-xl font-bold text-yellow-300 flex items-center gap-2">
          🌟 Smarty Vision & Mission
        </h1>
        <div></div>
      </header>

      <section className="px-4 py-2 text-center">
        <div className="flex flex-col items-center gap-3">
          <img
            src="/assets/imgFounders2.webp"
            alt="Co-founder"
            className="w-32 h-32 rounded-full border-2 border-teal-400 shadow-lg object-cover"
          />
          <blockquote className="text-teal-100 italic text-sm lg:text-base max-w-xl">
            "Smarty is here for Empowering every household to be smart, aware and data-driven — one step at a time!"  
          </blockquote>
          <cite className="text-yellow-300 font-semibold">Babita Sinha, Co-Founder</cite>
        </div>
      </section>

      <section className="px-4 py-2">
        <h2 className="text-lg lg:text-xl font-bold text-yellow-300 mb-3 flex items-center gap-2">Our Vision 🌈✨</h2>
        <ul className="space-y-2">
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            🏡 Enable every household to manage resources intelligently
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            ♻️ Reduce waste and maximize savings effortlessly
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            💰 Transform daily spending into smart decisions
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            🧠 Make data accessible, understandable, and actionable for everyone
          </li>
        </ul>
      </section>

      <section className="px-4 py-4">
        <h2 className="text-lg lg:text-xl font-bold text-yellow-300 mb-3 flex items-center gap-2">Our Mission 🚀💡</h2>
        <ul className="space-y-2">
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            ✨ Provide a simple, interactive platform for household inventory
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            📊 Offer insights and analytics on consumption and waste
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            🛒 Help plan smart shopping and optimize spending
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            🤖 Leverage AI to give personalized tips, reminders, and suggestions
          </li>
          <li className="bg-teal-900/40 p-3 rounded-md flex items-center gap-2">
            🥰 Empower women and families to make informed decisions with joy
          </li>
        </ul>
      </section>

      <section className="px-4 py-6">
        <h2 className="text-lg lg:text-xl font-bold text-yellow-300 mb-3 flex items-center gap-2">Why Smarty? 💛🤓</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          <div className="bg-teal-900/40 p-4 rounded-xl shadow-md flex flex-col items-center gap-2">
            🏡<span>Manage Household Inventory</span>
          </div>
          <div className="bg-teal-900/40 p-4 rounded-xl shadow-md flex flex-col items-center gap-2">
            ♻️<span>Reduce Waste & Save Money</span>
          </div>
          <div className="bg-teal-900/40 p-4 rounded-xl shadow-md flex flex-col items-center gap-2">
            💰<span>Track Expenses & Consumption</span>
          </div>
          <div className="bg-teal-900/40 p-4 rounded-xl flex flex-col items-center gap-2">
            🧠<span>Insights & Smart Tips</span>
          </div>
          <div className="bg-teal-900/40 p-4 rounded-xl flex flex-col items-center gap-2">
            📊<span>Visual Reports & Trends</span>
          </div>
          <div className="bg-teal-900/40 p-4 rounded-xl flex flex-col items-center gap-2">
            🥰<span>Empower Women & Families</span>
          </div>
        </div>
      </section>
     <footer className="bg-black border-t border-teal-800 text-teal-300 py-4 text-center text-xs">
        © 2025 Think5Whys Global DeepTech Solutions.
        <div className="mt-2 flex justify-center gap-4">
          <Link to="/about-us" className="hover:text-teal-400">About</Link>
          <Link to="/privacy-policy" className="hover:text-teal-400">Privacy</Link>
          <Link to="/terms-of-use" className="hover:text-teal-400">Terms</Link>
          <Link to="/contact-us" className="hover:text-teal-400">Contact</Link>
        </div>
      </footer>      
    </div>
  );
};

export default SmartyVision;
